export {default, KindOfChatType} from './ChatList';



// WEBPACK FOOTER //
// ./src/containers/ChatList/index.ts